<template>
  <v-skeleton-loader
    v-if="skeleton"
    :loading="skeleton"
    type="table"
  />

  <v-data-table
    v-else
    ref="table"
    :key="keySortablePositions"
    v-bind="$attrs"
    :value="selected"
    :headers="tableHeaders"
    :items="items"
    :item-class="getItemClass"
    :expanded.sync="expanded"

    :server-items-length="pagination.count"
    :show-expand="showExpand"

    :item-key="itemKey"
    :loading="loading"

    :show-select="showSelect"
    :single-expand="singleExpand"

    :options="options"
    :footer-props="footerProps"
    :hide-default-footer="hideDefaultFooter"

    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :multi-sort="multiSort"

    class="b-table"
    v-on="listeners"
    @pagination="onChangePagination"
    @update:sort-desc="onSort"
  >
    <!--  -->

    <template #item.sortable-positions>
      <v-icon
        class="js-sortable-positions-handle"
        :class="{ 'js-sortable-positions-handle--disabled': items.length < 2 }"
      >
        mdi-drag
      </v-icon>
    </template>

    <template #item.data-table-expand="props">
      <slot
        name="item.item.data-table-expand"
        v-bind="props"
        :data="getData(props.item)"
      >
        <BTableButtonExpand
          :active="props.isExpanded"
          :disabled="!checkShowExpand(getData(props.item), props)"
          @click="onExpand(props, getData(props.item))"
        />
      </slot>
    </template>

    <template #item.actions="{ header, item, index }">
      <div class="text-no-wrap">
        <template v-for="action in header.actions">
          <slot
            :name="`item.actions.${action.action}`"
            v-bind="{ action, header, item, index, data: getData(item) }"
          >
            <BTableButtonAction
              v-if="(
                (!item.actions
                  || action.action === viewAction
                  || action.action === copyAction
                  || item.actions.includes(action.action)) && isView(action, item)
              )"
              :key="action.action"
              :action="action"
              :index="index"
              :data="getData(item)"
              :list="list"
              v-on="$listeners"
              @change:positions="onChangePositions"
            />
          </slot>
        </template>
      </div>
    </template>

    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :data="getData(props.item)" :name="key" />
    </template>

    <!--  -->
  </v-data-table>
</template>


<script>
import BTable from '@/components/common/BTable.vue'
import { FormdataStatuses } from '@/typings/api/Formdata'
import { rootMapper } from '@/store/modules/root'

export default {
  name: 'BTableCommonFormdata',
  extends: BTable,
  computed: {
    ...rootMapper.mapGetters(['profile']),

    isSuperuser() {
      return this.profile.is_superuser
    },
  },
  methods: {
    isView(action, item) {
      if (this.isSuperuser) {
        return item.id !== null || action.action !== this.viewAction
      }
      return (item.id !== null & item.submitted_at !== null) || item.status === FormdataStatuses.submitted || item.status === FormdataStatuses.close
    },
  },
}
</script>
